"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var banali_react_leaflet_1 = require("banali-react-leaflet");
var leaflet_1 = __importDefault(require("leaflet"));
var Choropleth_1 = __importDefault(require("./Choropleth"));
var react_redux_1 = require("react-redux");
var languageSlice_1 = require("../../../features/languages/languageSlice");
var useTileLayer_1 = require("../../../hooks/useTileLayer");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var icon = leaflet_1.default.icon({
    iconSize: [25, 41],
    iconAnchor: [10, 41],
    popupAnchor: [2, -40],
    iconUrl: 'https://unpkg.com/leaflet@1.6/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.6/dist/images/marker-shadow.png',
});
var Map = function (_a) {
    var marker = _a.marker;
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    var tileLayer = useTileLayer_1.useTileLayer(currentLanguage);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.map_container },
        react_1.default.createElement(banali_react_leaflet_1.MapContainer, { zoomControl: false, style: { width: '100%', height: '11.25rem' }, attributionControl: false },
            react_1.default.createElement(banali_react_leaflet_1.TileLayer, { url: tileLayer, minZoom: 8 }),
            react_1.default.createElement(banali_react_leaflet_1.Marker, { position: marker, icon: icon }),
            react_1.default.createElement(Choropleth_1.default, { marker: marker }))));
};
exports.default = Map;
